import max from 'lodash/max';
import min from 'lodash/min';
import reduce from 'lodash/reduce';

import TreeNode from 'src/presentation/components/pages/ivr/components/ivrTree/models/TreeNode';
import { RECT_MARGIN, NodeSize } from 'src/presentation/components/pages/ivr/constants/ivrTreeConstants';

type NodesRectType = {
  x0?: number;
  y0?: number;
  x1?: number;
  y1?: number;
};

class NodesRect {
  private _x0;
  private _y0;
  private _x1;
  private _y1;

  constructor({ x0, y0, x1, y1 }: NodesRectType) {
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
  }

  get x0() {
    return this._x0;
  }

  get x1() {
    return this._x1;
  }

  get y0() {
    return this._y0;
  }

  get y1() {
    return this._y1;
  }

  get width() {
    return this._x1 - this._x0;
  }

  get height() {
    return this._y1 - this._y0;
  }
}

export const getNodesRect = (nodes: TreeNode[]): NodesRect => {
  const rect = reduce(
    nodes,
    (result: NodesRectType, node: TreeNode) => {
      result.x0 = min([result.x0, node.x]);
      result.y0 = min([result.y0, node.y]);

      result.x1 = max([result.x1, node.x + NodeSize.Default.width]);
      result.y1 = max([result.y1, node.y + NodeSize.Default.height]);
      return result;
    },
    { x0: undefined, y0: undefined, x1: undefined, y1: undefined }
  );

  return new NodesRect({
    x0: rect.x0 || 0 - RECT_MARGIN,
    y0: rect.y0 || 0 - RECT_MARGIN,
    x1: rect.x1 || 0 + RECT_MARGIN,
    y1: rect.y1 || 0 + RECT_MARGIN,
  });
};
